import $ from '@modules/jquery-import';
import contains from 'ramda/src/contains';
import appLogger from '@core/LoggingProvider';
import orderUtil from './orderUtil';
import OrderItemController from './orderItemController';
import View from '@core/View';
import OrdersService from '@services/OrdersService';
import assign from 'object-assign';

const ORDER_PROCESS_ERROR_MSG = `We're sorry, there was a problem while attempting to process this order`;

/**
 * OrderItemPendingController
 * Manages pending order item on the page that have a data-order-guid attached to it
 * Delgates order approval status, PO# updates nad triggers change events to the document
 * @requires OrderItemController
 * @el {HTMLElement} - the order item container
 */

export default OrderItemController.extend( {

    defaults: {
        request: OrdersService.getOrderDetails
    },

    currentStatus: null,

    elements: {
        '.accordion-content': 'contentArea',
        '.odr-po': 'pofieldWrapper',
        '.odr-po input': 'pofield',
        '.odr-notes-field--po input[type="text"]': 'pofieldAlt',
        '.odr-actions': 'orderActions',
        '.odr-status': 'orderStatusBadge',
        '[id^="customernotes-fieldset-"]': 'messageFieldSet',
        '[id^="rejectnotes-"]': 'messageField'
    },

    events: {
        // Caveat - current implementation does not inherit event object. Events from parent must be inherited manually
        // parent
        'click .print-invoice': 'handlePrintInvoice',
        'contenteditable:saved': 'handlePONumber',
        'keypress pofieldAlt': 'onKeypress',
        'keypress messageField': 'onKeypress',
        // extend
        'click .odr-actions .button': 'handleOrderAction',
        'orderstatus:change': 'updateOrderStatusBadge'
    },

    init: function ( el, options ) {

        this.options = this.options || {};
        assign( this.options, this.defaults, options || {} );

        this._super( el, this.options );

        if ( !this.orderNumber ) {
            return;
        }

        this.el = $( el );
        this.isPendingOrderView = !!this.el.parents( '.adm-pending-orders' )[0];
        this.orderApprovalDialogView = new View( 'lgpOrderApprovalDialog' );
        this.orderStatusBadgeView = orderUtil.orderStatusBadgeView;
        this.messageboxView = new View( 'messagebox' );
        this.messageboxWrap = $( '<div/>' );
        this.fieldSetMessagebar = $( '<div class="order-action-message pt-4"/>' );
        this.update_elements();

        console.log( 'this.fieldSetMessagebar', this.fieldSetMessagebar );
        // patch - remove server rendered messageFields due to PO# update
        // todo - remove server rendered message fields
        if ( this.messageFieldSet && this.messageFieldSet[0] ) {
            this.messageFieldSet.remove();
        }

        // add message dialog containers
        const orderApprovalDialog = this.orderApprovalDialogView.render( {
                orderNumber: this.orderNumber,
                poNumber: this.pofield.val()
            } ),
            wrapper = $( '<div class="hidden">' );

        this.el.append( wrapper.html( orderApprovalDialog ) );
        this.update_elements();

        // ensure dialog pofield gets updated when contenteditable field changes
        this.bind( 'pofield:update', ( e, {orderNumber, poNumber} ) => {
            if ( orderNumber === this.orderNumber ) {
                this.pofieldAlt.val( poNumber );
            }
        } );

        this.messageFieldSet.prepend( this.fieldSetMessagebar );

        // bind reset events
        $( document ).on( 'orderitemapproval:off', this.resetDialog.bind( this ) );
    },

    handleAccordionToggle: function ( e ) {
        this._super( e );
        this.resetDialog();
    },

    handleOrderAction: function ( e ) {
        e.preventDefault();
        e.stopPropagation();

        const $target = $( e.currentTarget ),
            action = $target.attr( 'data-action' ),
            targetIsApprovalStatusButton = contains( action, ['reject', 'approve'] ),
            $orderActions = $target.parents( '.odr-actions' );

        if ( targetIsApprovalStatusButton ) {
            this.currentStatus = action;
        }

        this.clearMessageBar();
        if ( 'submit' === action ) {
            this.submitForm( $target );
        }
        else {
            $( document ).trigger( 'orderitemapproval:off' );
            this.toggleApprovalDialog( $orderActions, targetIsApprovalStatusButton );
        }
    },

    toggleProcessing: function ( isProcessing ) {
        this.orderActions.toggleClass( 'is-processing', isProcessing );
    },

    /**
     * submitForm:
     * handle the submission/errors for form and always clear out currentProcess state
     */
    submitForm: function () {
        this.toggleProcessing( true );
        this.setStatusMessage( 'processing', 'Submitting...' );

        this.updateOrderStatus( this.currentStatus )
            .then( ( {order} ) => {
                $( document ).trigger( 'orderitemapproval:off' );
                this.removePOField();

                if ( this.isPendingOrderView ) {
                    this.closeOrderItem( 'approve' );
                    $( '#body-content' ).scrollToElement( {effect_speed: 300} );
                }
                else {
                    this.setOrderStatus( 'approve' );
                    this.el.trigger( {type: 'close:accordion', item: this.el} ).scrollToElement(); // account for fixed header;
                    this.pofieldWrapper.find( 'span' ).text( order.poNumber );
                }

            } )
            .catch( err => {
                appLogger.capture( err );
                console.error( '[updateOrderStatus] Error', err );
                this.setStatusMessage( 'error', err.displayMessage || ORDER_PROCESS_ERROR_MSG );
            } )
            .finally( () => this.toggleProcessing( false ) );

        return false;
    },

    onKeypress ( e ) {
        if ( e.which === 13 ) {
            return this.submitForm();
        }
    },

    updateOrderStatus: function ( status ) {
        if ( 'approve' === status ) {
            let poNumber = this.pofieldAlt.val();
            return (!poNumber)
                // if po# field invalid reject promise
                ? Promise.reject( {displayMessage: 'Please provide a PO#'} )
                // else make sure the PO number is updated on the server
                : this.approveOrder( {poNumber} );

        }
        else if ( 'reject' === status ) {
            return this.rejectOrder( this.messageField.val() );
        }
    },

    setOrderStatus: function ( status ) {
        this.el.attr( 'data-order-status', status ).trigger( 'orderstatus:change', status );
    },

    updateOrderStatusBadge: function ( e, status ) {
        const newBadgeHtml = orderUtil.renderStatusBadge( status );
        this.orderStatusBadge.replaceWith( newBadgeHtml );
    },

    closeOrderItem: function ( status ) {
        const el = this.el;

        el.slideUp( 250, () => {
            el.remove();
            this.updatePriorityHeaders();
            this.changePendingCountBy( 1 );
            if ( 'approve' === status ) {
                this.changeApprovedCountBy( 1 );
            }
        } );

        this.destroy();
        $( document ).trigger( 'orderitem:closed' );

        return this.el;
    },

    updatePriorityHeaders: function () {
        $( '.accordion-division' ).each( function () {
            if ( !$( this ).next().hasClass( 'accordion-item' ) ) {
                $( this ).slideUp( 200 );
            }
        } );
    },

    setStatusMessage: function ( type, message ) {
        const messageView = this.messageboxView.render( {
            type: type || '',
            message: message || ''
        } );
        this.fieldSetMessagebar.html( messageView );
    },

    approveOrder: function ( {poNumber} ) {
        return OrdersService.approveOrder( {
            orderNumber: this.orderNumber,
            poNumber
        } );
    },

    rejectOrder: function ( message ) {
        message = message || '';
        return OrdersService.rejectOrder( {
            orderNumber: this.orderNumber,
            adminNotes: message.trim()
        } );
    },

    toggleApprovalDialog: function ( target, isApproval ) {
        if ( isApproval ) {
            this.showMessageBox( this.currentStatus );
        }

        target.prepend( this.messageFieldSet )
            .attr( 'data-action-state', isApproval ? 'notes' : 'approval' )
            .attr( 'data-dialog-status', this.currentStatus );
    },

    showMessageBox: function ( status ) {
        const isApprove = 'approve' === status,
            message = this.messageboxView.render( {
                type: isApprove
                    ? 'success'
                    : 'notice',
                message: isApprove
                    ? 'Approving order'
                    : 'Rejecting order'
            } );

        this.messageFieldSet.prepend( this.messageboxWrap.html( message ) );
        const positionTo = this.el.hasClass( 'active' )
            ? 'bottom'
            : 'top';
        this.scrollToOrderItem( positionTo );
        setTimeout( () => {
            this.messageField.focus();
        }, 0 );
    },

    resetDialog: function () {
        this.clearMessageBar();
        this.orderActions.attr( 'data-action-state', 'approval' );
    },

    clearMessageBar: function () {
        this.fieldSetMessagebar.empty();
    },

    changePendingCountBy: function ( count ) {
        $( document ).trigger( 'orderitempending:change', {count: count} );
    },

    changeApprovedCountBy: function ( count ) {
        $( document ).trigger( 'orderitemapproved:change', {count: count} );
    },

    destroy: function () {
        this.el.off( 'click' );
        this.el.off( 'contenteditable:saved' );
    }

} );
